import { FormattedMessage } from 'react-intl';

interface Props {
  message: string;
}

export default function SchedulesErrorState({ message }: Props) {
  return (
    <div
      className="px-5 py-3 text-center text-sm text-red-600"
      role="alert"
    >
      <FormattedMessage id="accounts.card.error" values={{ message }} />
    </div>
  );
}
